import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  show(): void {
    const el = document.getElementById('app-spinner');
    if (el) el.classList.remove('hide');
  }

  hide(): void {
    const el = document.getElementById('app-spinner');
    if (el) el.classList.add('hide');
  }

  toggle(show: boolean): void {
    if (show) {
      this.show();
    } else {
      this.hide();
    }
  }
}
